import { buildInfoPages } from "@plaatplan/i18n";
import { useMemo } from "react";
import { useLocale } from "./useLocale.js";

export function useInfoPages() {
  const { preferences } = useLocale();
  return useMemo(
    () => buildInfoPages(preferences.locale),
    [preferences.locale],
  );
}
